import React from 'react';
import styled from 'styled-components';
import MotifRadioButtonGroup from '@ey/motif-react-wrapper/RadioButtonGroup';

export default function RadioButtonGroup(props) {
	const {id, className, name, required, disabled, children} = props;
	return (
		<StyledMotifRadioButtonGroup id={id} className={className} name={name} required={required} disabled={disabled}>
			{children}
		</StyledMotifRadioButtonGroup>
	);
}

const StyledMotifRadioButtonGroup = styled(MotifRadioButtonGroup)``;
